// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"1cb31c33","383":"678b6dce","453":"ee30b0a5","648":"e76bf0a0"}[chunkId] + ".chunk.js";
};